import React from 'react';
import { motion } from 'framer-motion';
import { Navbar, ContactCTA, Footer, LazyImage, NigeriaMap } from '../../components';
import styles from './Impact.module.css';


const HERO_BG  = 'https://res.cloudinary.com/dhjzovpof/image/upload/v1773601530/7e233273-f52c-4734-9900-4549653c6bb3_1_x2mgrd.jpg';
const SUST_BG  = 'https://res.cloudinary.com/dhjzovpof/image/upload/v1775326078/c8694486c5ad908fcc303067b8217588ee6c73d5_1_pyfhny.jpg';

const SHIELD_ICON = 'https://res.cloudinary.com/dhjzovpof/image/upload/v1773601631/273b74a0-3c2b-4186-a60a-1ea56605294b_wigevl.svg';
const SUN_ICON    = 'https://res.cloudinary.com/dhjzovpof/image/upload/v1773601669/1a73c250-31bd-44a9-9a2c-60d76bd1dbd5_na4yqg.svg';
const ROAD_ICON   = 'https://res.cloudinary.com/dhjzovpof/image/upload/v1773601704/d3c29438-6489-4fc9-8efd-ef27093e6033_yiyiin.svg';

const PIN_ICON_1  = 'https://res.cloudinary.com/dhjzovpof/image/upload/v1773601768/2cbd4203-b615-4f94-ba85-cf694e3ec80a_ftwume.svg';
const PIN_ICON_2  = 'https://res.cloudinary.com/dhjzovpof/image/upload/v1773601804/d7f43493-2145-4a85-a0fe-1e24d3ac0a54_boyng9.svg';
const PIN_ICON_3  = 'https://res.cloudinary.com/dhjzovpof/image/upload/v1773601849/344f3f73-6fc6-456b-9658-59834d0d6644_rwbruo.svg';

const fadeUp = (delay = 0) => ({
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut', delay } },
});

const STATS = [
  {
    num: '40+',
    label: 'Projects Completed',
    bg: '#CF181F',
    textClr: '#faebe9',
    icon: PIN_ICON_1,
    desc: 'A decade of high-stakes civil and electrical engineering projects successfully executed for public and private partners.',
  },
  {
    num: '100%',
    label: 'Safety Assurance',
    bg: '#C88415',
    textClr: '#fff6e8',
    icon: PIN_ICON_2,
    desc: 'We adhere to the most stringent international HSE standards, ensuring zero-compromise safety for our team and the public.',
  },
  {
    num: '20+',
    label: 'States Covered',
    bg: '#1E2328',
    textClr: '#fafafa',
    icon: PIN_ICON_3,
    desc: 'Our logistical footprint spans across the federation, ensuring top-tier infrastructure reaches every corner of the nation.',
  },
];

const TICKER_ITEMS = [
  { city: 'LAGOS',  project: 'FAMFA TOWERS || Road Marking / Directional Signs And Symbols' },
  { city: 'IBADAN', project: 'IBADAN PLANET PROJECT || Road Marking/Directional Signs And Symbols' },
  { city: 'ABUJA',  project: 'MABUSHI BUS TERMINAL || Road Marking/Directional Signs And Symbols' },
  { city: 'ABUJA',  project: 'ZENITH MEDICAL KIDNEY CENTER || Road Constructions & Infrastructure Development' },
  { city: 'LAGOS',  project: 'ST AGNES CATHOLIC CHURCH || Road Marking/Directional Signs And Symbols' },
  { city: 'IMO',    project: 'NAZE JUNCTION || Road Marking/Directional Signs And Symbols' },
  { city: 'NIGER',  project: 'MINNA ROAD MARKING WESTERN BYPASS || Traffic Management & Road Safety Solutions' },
  { city: 'ABUJA',  project: 'GODAB ESTATE, F.C.T || Traffic Management & Road Safety Solutions' },
];

const SDG_ITEMS = [
  { icon: SHIELD_ICON, label: 'Sustainable Cities and Communities.', bg: '#FAEBE9' },
  { icon: SUN_ICON,    label: 'Affordable and Clean Energy (Solar).', bg: '#FFF6E8' },
  { icon: ROAD_ICON,   label: 'Industry, Innovation, and Infrastructure.', bg: '#E8E8E8' },
];

// const STATE_INFO = {
//   lagos:     { region: 'SOUTHWEST',    stats: [{ value: '3+', label: 'Projects' }], projects: ['FAMFA TOWERS — Road Marking', 'ST AGNES CATHOLIC CHURCH — Road Marking'] },
//   oyo:       { region: 'SOUTHWEST',    stats: [{ value: '1+', label: 'Projects' }], projects: ['IBADAN PLANET PROJECT — Road Marking'] },
//   fct:       { region: 'NORTH CENTRAL',stats: [{ value: '3+', label: 'Projects' }], projects: ['MABUSHI BUS TERMINAL', 'ZENITH MEDICAL KIDNEY CENTER', 'GODAB ESTATE — Traffic Management'] },
//   imo:       { region: 'SOUTHEAST',    stats: [{ value: '1+', label: 'Projects' }], projects: ['NAZE JUNCTION — Road Marking'] },
//   niger:     { region: 'NORTH CENTRAL',stats: [{ value: '1+', label: 'Projects' }], projects: ['MINNA ROAD MARKING — WESTERN BYPASS'] },
//   kano:      { region: 'NORTHWEST',    stats: [{ value: '2+', label: 'Projects' }], projects: ['Kano Industrial Zone Road Works'] },
//   rivers:    { region: 'SOUTH SOUTH',  stats: [{ value: '2+', label: 'Projects' }], projects: ['Port Harcourt Bypass', 'Warri Terminal Access'] },
//   kaduna:    { region: 'NORTHWEST',    stats: [{ value: '1+', label: 'Projects' }], projects: ['Kaduna Eastern Bypass'] },
// };

export default function Impact() {
  return (
    <div className={styles.page}>
      <Navbar theme="light" cta="Contact Us" ctaTo="/contact" />

      {/* ── HERO ──────────────────────────────────────────── */}
      <section className={styles.hero}>
        <div className={styles.heroBg} aria-hidden="true">
          <LazyImage src={HERO_BG} alt="" />
          <div className={styles.heroGradient} />
        </div>
        <div className={styles.heroLabel}>
          <h1 className={styles.heroTitle}>OUR IMPACT</h1>
        </div>
      </section>

      {/* ── INTRO ROW ─────────────────────────────────────── */}
      <motion.section
        className={styles.intro}
        variants={fadeUp(0)}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <h2 className={styles.introTitle}>Engineering National Progress.</h2>
        <p className={styles.introDesc}>
          From urban hubs to remote regions, our work defines the terms of technical mastery
          across Nigeria. We don't just build; we leave a legacy of precision and durability.
        </p>
      </motion.section>

      {/* ── STATS ROW ─────────────────────────────────────── */}
      <section className={styles.statsRow}>
        {STATS.map((s, i) => (
          <motion.div
            key={i}
            className={styles.statCard}
            style={{ background: s.bg, '--stat-clr': s.textClr }}
            variants={fadeUp(i * 0.1)}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
          >
            <div className={styles.statTop}>
              <div className={styles.statText}>
                <span className={styles.statNum}>{s.num}</span>
                <span className={styles.statLabel}>{s.label}</span>
              </div>
              <div className={styles.statIconBox}>
                <img src={s.icon} alt="" className={styles.statIcon} />
              </div>
            </div>
            <p className={styles.statDesc}>{s.desc}</p>
          </motion.div>
        ))}
      </section>

      {/* ── MAP SECTION ───────────────────────────────────── */}
      <section className={styles.mapSection}>
        <motion.div
          className={styles.mapHeader}
          variants={fadeUp(0)}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <h2 className={styles.mapTitle}>Our Reach in Real-Time</h2>
          <p className={styles.mapDesc}>
            Hover over the markers to explore our specific impact in each state. Our teams are
            currently mobilized across the country, transforming the Nigerian landscape one
            project at a time.
          </p>
        </motion.div>
        {/*<motion.div*/}
        {/*  className={styles.mapWrap}*/}
        {/*  variants={fadeUp(0.1)}*/}
        {/*  initial="hidden"*/}
        {/*  whileInView="visible"*/}
        {/*  viewport={{ once: true, amount: 0.1 }}*/}
        {/*>*/}
          <NigeriaMap height="100%" className={styles.portfolioMap} />
        {/*</motion.div>*/}
      </section>

      {/* ── TICKER BAR ────────────────────────────────────── */}
      <div className={styles.ticker} aria-label="Project references">
        <div className={styles.tickerFadeL} aria-hidden="true" />
        <div className={styles.tickerFadeR} aria-hidden="true" />
        <div className={styles.tickerTrack}>
          {[...TICKER_ITEMS, ...TICKER_ITEMS].map((item, i) => (
            <span key={i} className={styles.tickerItem}>
              <span className={styles.tickerCity}>{item.city}:</span>
              <span className={styles.tickerProject}>&nbsp;{item.project}</span>
              <span className={styles.tickerSep}>+++</span>
            </span>
          ))}
        </div>
      </div>

      {/* ── SUSTAINABILITY SECTION ────────────────────────── */}
      <section className={styles.sustSection}>
        <div className={styles.sustBg} aria-hidden="true">
          <LazyImage src={SUST_BG} alt="" className={styles.sustBgImg} />
          <div className={styles.sustBgOverlay} />
        </div>
        <motion.div
          className={styles.sustCard}
          variants={fadeUp(0)}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <h2 className={styles.sustTitle}>Future-Proofing Nigeria</h2>
          <p className={styles.sustBody}>
            We believe that infrastructure should be as sustainable as it is strong. Tektron+
            integrates renewable energy and eco-friendly materials into every project to minimize
            environmental impact and maximize long-term efficiency.
          </p>
          <div className={styles.sdgRow}>
            {SDG_ITEMS.map((s, i) => (
              <div key={i} className={styles.sdgItem}>
                <div className={styles.sdgIconBox} style={{ background: s.bg }}>
                  <img src={s.icon} alt="" className={styles.sdgIcon} />
                </div>
                <span className={styles.sdgLabel}>{s.label}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </section>

      <ContactCTA />
      <Footer />
    </div>
  );
}
